import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '../styles';
import { TH } from '../ContentTags';
const useStyles = makeStyles(({ spacing, palette }) => ({
    root: {
        lineHeight: '21px',
        padding: spacing(2),
        borderRight: `1px solid ${palette.grey.main}`,
        borderBottom: `1px solid ${palette.grey.main}`,
        textAlign: 'left',
        flexGrow: ({ cellWidth }) => (cellWidth === 'auto' ? 1 : 0),
        flexBasis: ({ cellWidth }) => cellWidth,
    },
}));
export default ({ className, children, cellWidth = 'auto' }) => {
    const classes = useStyles({ cellWidth });
    return React.createElement(TH, { className: classNames(className, classes.root) }, children);
};
//# sourceMappingURL=Header.js.map